module.exports = __webpack_public_path__ + "img/kermit.790aa345.png";